import { MatDialog } from "@angular/material/dialog";
import { CreateAuctionComponent } from "src/app/features/rooms/component/createAuction/createAuction.component";
import { SuccessAddItemComponent } from "src/app/features/rooms/component/createAuction/success-add-item/success-add-item.component";


export function OpenCreateItemDialog(RoomDetailes: any, dialog: MatDialog) {
    dialog.closeAll();
    const dialogRef = dialog.open(CreateAuctionComponent, {
        width: 'auto',
        // minWidth: "400px",
        data: {
            room_id: RoomDetailes.id,
            maxDate: RoomDetailes.end_date,
            minDate: RoomDetailes.start_date,
            in_multi_room: RoomDetailes.is_multi_auction
        },
        disableClose: true,
        panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res: any) => {
        if (res === true) {
            openSuccessMessageDialog(RoomDetailes, dialog);
            return true;
        }
        else {
            return false;
        }

    })

}

function openSuccessMessageDialog(RoomDetailes: any, dialog: MatDialog) {
    const dialogRef = dialog.open(SuccessAddItemComponent, {
        data: { type: "add" },
        width: '550px',
        disableClose: true,
        panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
        console.log(res);

        if (res) {
            OpenCreateItemDialog(RoomDetailes, dialog)
            return false;
        }
        else {
            return true;
        }
    });
}